// extracted by mini-css-extract-plugin
module.exports = {"menuColor":"#001529","menuTextColor":"#bbb","menuActiveTextColor":"#409eff"};